var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cls from 'classnames';
const shortDays = {
    0: 'Sun',
    1: 'Mon',
    2: 'Tue',
    3: 'Wed',
    4: 'Thu',
    5: 'Fri',
    6: 'Sat',
};
const shortMonths = {
    0: 'Jan',
    1: 'Feb',
    2: 'Mar',
    3: 'Apr',
    4: 'May',
    5: 'Jun',
    6: 'Jul',
    7: 'Aug',
    8: 'Sep',
    9: 'Oct',
    10: 'Nov',
    11: 'Dec',
};
function nth(number) {
    if (number > 3 && number < 21) {
        return 'th';
    }
    switch (number % 10) {
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
}
const DateModel = window.Date;
// TODO: Support different formats.
//       For now only "ddd Do MMM" is required so it's the only supported,
//       to omit any unnecessary libraries.
function buildOutput(datetime) {
    const date = new DateModel(DateModel.parse(datetime));
    return `${shortDays[date.getDay()]} ${date.getDate()}${nth(date.getDate())} ${shortMonths[date.getMonth()]}`;
}
// TODO: Localize or use external library
export function Date(_a) {
    var { datetime, className } = _a, props = __rest(_a, ["datetime", "className"]);
    if (!datetime) {
        return null;
    }
    const theDatetime = typeof datetime === 'string' ? datetime : datetime.toISOString();
    const finalClassName = cls('WhSearch-Date', className);
    return (React.createElement("time", Object.assign({}, props, { className: finalClassName, dateTime: theDatetime }), buildOutput(theDatetime)));
}
//# sourceMappingURL=Date.js.map